<template>
  <div id="area-container">
    <div class="cover">
      <img class="cover-image" :src="image" />
      <div class="info">
        <div class="has-l-heading-size title">
          {{ data.title }}
        </div>
        <div class="has-l-body-size description">
          {{ data.description }}
        </div>
      </div>
    </div>
    <div class="game-list">
      <template v-for="(game, i) in data.games">
        <GameCard
          v-bind="game"
          :key="i"
        />
      </template>
    </div>
  </div>
</template>

<script>
import {provide, computed} from '@vue/composition-api'

import * as providers from '@area/providers'

export default {
  props: {
    data: {type: Object, required: true},
  },
  setup ({data}, context) {
    provide(providers.OPTIONS, {
      assetBaseUrl: data.assetBaseUrl,
    })

    return {
      image: computed(() => {
        return `${data.assetBaseUrl}${data.imageUrl}`
      }),
    }
  },
}
</script>

<style scoped lang="scss">
#area-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(180deg, #5B4E98 0%, #7C7FAC 25%, #94A3BB 75%, #B9E5D6 100%);
  color: variables.$color-white;
  gap: 100px;
  padding: 20px 0 200px 0;
  min-height: 100vh;
  box-sizing: border-box;

  > * {
    width: 1024px;
  }

  .cover {
    display: flex;
    align-items: flex-end;
    gap: 20px;

    .cover-image {
      width: 600px;
    }

    .title {
      margin-top: 12px;
      margin-bottom: 16px;
    }
  }

  .game-list {
    box-sizing: border-box;
    position: relative;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    column-gap: 32px;
    row-gap: 32px;
    padding: variables.$spacing-16;
  }

  // Mobile and tablet
  @include media.query($to: 1024) {
    gap: 40px;

    > * {
      width: 100%;
    }
    .cover {
      flex-direction: column;

      .cover-image {
        width: 100%;
      }

      .info {
        padding: 0 16px;
      }
    }

    .game-list {
      width: calc(100% -32px);
      gap: 16px;
      padding: 0;
    }
  }
}

</style>
